window.slate = window.slate || {};
window.theme = window.theme || {};

// =require bundle.js

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.eventNamespace
      ? 'focusin.' + options.eventNamespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace rte
 */

slate.rte = {

  wrapTable: function() {
    $('.rte table').wrap('<div class="rte__table-wrapper"></div>');
  },

  iframeReset: function() {
    var $iframeVideo = $('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]');
    var $iframeReset = $iframeVideo.add('.rte iframe#admin_bar_iframe');

    $iframeVideo.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="rte__video-wrapper"></div>');
    });

    $iframeReset.each(function() {
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();
    this.colorEnabled = options.product.options.indexOf('Color') ==! -1;

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();


/*================ Sections ================*/
/**
 * Header Section Script
 * ------------------------------------------------------------------------------
 * Contains scripts coupled to the header section.
 *
 */

theme.Header = (function() {
  var selectors = {
    toggleNav: '[data-toggle-nav]'
  };

  function Header(container) {
    this.$container = $(container);
    this.namespace = '.header';

    this.bindToggleNavEvents();
  }

  Header.prototype = $.extend({}, Header.prototype, {
    bindToggleNavEvents: function() {
      $(selectors.toggleNav).on('click', function(e) {
        $('html').toggleClass('is-nav-active');
      });
    },

    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Header;
})();

/**
 * Navigation Section Script
 * ------------------------------------------------------------------------------
 * Contains scripts coupled to the navigation section.
 * Also binds nav toggle button in header for mobile.
 *
 */

theme.Navigation = (function() {
  var selectors = {
    nav: '[data-nav]',
    navLimit: '[data-nav-limit]',
    navItem: '[data-nav-item]'
  };

  function Navigation(container) {
    this.$container = $(container);
    this.namespace = '.nav';

    if (window.matchMedia('(max-width: 759px)').matches) {
      this.bindNavEvents();
    };

    if (window.matchMedia('(min-width: 760px)').matches) {
      this.initNavLimit();

      $('body').on('resetNavLimit', function() {
        setTimeout(function() {
          Waypoint.refreshAll();
        });
      });
    };
  }

  Navigation.prototype = $.extend({}, Navigation.prototype, {
    bindNavEvents: function() {
      $(selectors.navItem).on('click', function(e) {
        if($(this).next('ul').length != 0) {
          e.preventDefault();
          $(this).toggleClass('is-active');
        }
      });
    },

    initNavLimit: function() {
      var waypoint = new Waypoint({
        element: document.querySelectorAll(selectors.navLimit),
        handler: function(direction) {
          if (direction === 'down') {
            $(selectors.nav).addClass('is-unstuck');
            $(selectors.nav).css('top', this.triggerPoint);
          } else {
            $(selectors.nav).removeClass('is-unstuck');
            $(selectors.nav).css('top', '');
          }
        },
        offset: function() {
          return $(selectors.nav).outerHeight()
        }
      });
    },

    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Navigation;
})();

/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = (function() {

  var selectors = {
    activationDevice: '[data-activation-device]',
    activationQuantity: '[data-activation-quantity]',
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    colorOption: '[data-color-option]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    devices: '[data-devices]',
    originalSelectorId: '[data-product-select]',
    earImpressionId: '[data-ear-impression-id]',
    earImpressionIdTrigger: '[data-ear-impression-id-trigger]',
    priceWrapper: '[data-price-wrapper]',
    productAddons: '[data-product-addons]',
    productCarousel: '[data-product-carousel]',
    productExtraCta: '[data-product-extra-cta]',
    productFeaturedImage: '[data-product-featured-image]',
    productForm : '[data-product-form]',
    productImages: '[data-product-images]',
    productImagesJson: '[data-product-images-json]',
    productImageTpl: '[data-product-image-tpl]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price-el]',
    productQtySelect: '[data-quantity-select]',
    productThumbs: '[data-product-single-thumbnail]',
    productType: '[data-product-type]',
    productVideo: '[data-product-video]',
    productVideoLink: '[data-product-video-link]',
    productVideoTitle: '[data-product-video-title]',
    productVideoThumb: '[data-product-video-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]',
    swatches: '[data-swatches]',
    swatchesInput: '[data-swatches-input]',
    swatchesMirror: '[data-swatches-mirror]',
    swatchesMirrorInput: '[data-swatches-mirror-input]',
    tabs: '[data-tabs]',
    tabsContent: '[data-tabs-content]',
    tabsNav: '[data-tabs-nav]'
  };

  var isElementInViewport = function (el) {

    //special bonus for those using jQuery
    if (typeof jQuery === "function" && el instanceof jQuery) {
      el = el[0];
    }

    var rect = el.getBoundingClientRect();

    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /*or $(window).height() */
      rect.right <= (window.innerWidth || document.documentElement.clientWidth) /*or $(window).width() */
    );
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);
    var sectionId = this.$container.attr('data-section-id');

    this.settings = {};
    this.namespace = '.product';
    this.productType = this.$container.attr('data-product-type');
    this.multiplier = 1;

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

    if ($(selectors.productFeaturedImage).length > 0) {
      this.settings.imageSize = slate.Image.imageSize($(selectors.productFeaturedImage, this.$container).attr('src'));
    }

    this.initVariants();


    if (this.variants.colorEnabled) {
      this.productImages = JSON.parse($(selectors.productImagesJson, this.$container).html());
      this.productImageTpl = $(selectors.productImageTpl, this.$container).html().trim();
      this.colorOption = $(selectors.colorOption, this.$container).attr(selectors.colorOption.replace(/^\[|\]$/g,''));
      var productImagesUrls = this.productImages.map(function(image) { return image.url; }, this);
      slate.Image.preload(productImagesUrls, this.settings.imageSize);
    } else {
      slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);
    }

    this.initTooltips();
    this.initGallery();
    this.initCarousel();
    this.initVideos();
    this.initVideosGallery();
    this.initPricing();
    this.initEarImpressionId();
    this.initSwatches();
    this.bindTabsEvents();

    if (this.productType == 'Activation') {
      this.initDevices();
    }

    if ($(selectors.productExtraCta).length > 0) {
      if (isElementInViewport($(selectors.productExtraCta))) {
        $(selectors.productExtraCta).remove();
      } else {
        $(selectors.productExtraCta).css('visibility', 'visible');
      }
    }

    var reviewsCheck = setInterval(function() {
      if ($('.spr-container').length > 0) {
        $('body').trigger('resetNavLimit');
        clearInterval(reviewsCheck);
      }
    }, 250);

    var relatedProductsCheck = setInterval(function() {
      if ($('.products--related').length > 0) {
        $('body').trigger('resetNavLimit');
        clearInterval(relatedProductsCheck);
      }
    }, 250);

    setTimeout(function() {
      $('body').trigger('resetNavLimit');
    }, 3000);
  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Handles change events from the variant inputs
     */
    initVariants: function() {
      var options = {
        $container: this.$container,
        enableHistoryState: this.$container.data('enable-history-state') || false,
        singleOptionSelector: selectors.singleOptionSelector,
        originalSelectorId: selectors.originalSelectorId,
        product: this.productSingleObject
      };

      this.variants = new slate.Variants(options);

      this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
      this.$container.on('variantImageChange' + this.namespace, this.updateProductImages.bind(this));
    },

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }

      if (variant.available) {
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      $(selectors.productPrice, this.$container)
        .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

      $(selectors.productFeaturedImage, this.$container).attr('src', sizedImgUrl);
    },

    /**
     * Updates the DOM with the specified images URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImages: function(evt) {
      var variant = evt.variant;
      var variantColor = variant[this.colorOption];
      var variantImages = this.productImages.filter(function(image) {
        return image.color === variantColor;
      });

      var currentImageName;
      if($(selectors.productCarousel, this.$container).length) {
        var currentSlide = $(selectors.productCarousel, this.$container).slick('slickCurrentSlide');
        var $slides = $(selectors.productCarousel, this.$container).slick("getSlick").$slides;
        currentImageName = $slides.eq(currentSlide).data('name');
      } else {
        currentImageName = $(selectors.productImages, this.$container).find('div').data('name');
      }

      var $newProductImages = $(selectors.productImages, this.$container).clone().empty();

      var newCarouselIndex;
      variantImages.forEach(function(image, i) {
        if(image.name === currentImageName) newCarouselIndex = i;

        var $tpl = $(this.productImageTpl);
        $tpl.attr('data-name', image.name);
        $tpl.find('a').attr('href', image.url);
        $tpl.find('img').attr('src', slate.Image.getSizedImageUrl(image.url, this.settings.imageSize));
        $newProductImages.append($tpl);
      }, this);

      $newProductImages.waitForImages((function() {
        $(selectors.productCarousel, this.$container).slick('unslick');
        $(selectors.productImages, this.$container).removeAttr('data-product-carousel');
        $(selectors.productImages, this.$container).html($newProductImages.html());
        this.initGallery();
        if (variantImages.length > 1) {
          $(selectors.productImages, this.$container).attr(selectors.productCarousel.replace(/^\[|\]$/g,''), '');
          this.initCarousel(newCarouselIndex);
        }
        // Fixes images not resizing correctly on variant change
        $(selectors.productCarousel, this.$container).slick('setPosition');
      }).bind(this));
    },

    initPricing: function() {
      this.currentPrice = this.variants.currentVariant.price;
      this.bindCheckboxPrices();
      this.bindRadioPrices();
      this.bindSelectPrices();
      this.bindQuantityPricing();
      this.bindVariantPricing();
    },

    /**
     * Updates the DOM with tooltips triggers
     */
    initTooltips: function() {
      var infoRegex = /\+\+\+tooltip:.+\+\+\+/g;
      var $productContent = $(this.$container).find('.product__content');
      var matches = $productContent.html().match(infoRegex);
      if (matches) {
        matches.forEach(function(match) {
          var info = match.replace(/\+/g, '').split(':');
          $productContent.html(function(i, content) {
            return content.replace(match, '<span class="tooltip product__tooltip" data-tooltip-content="#tooltip_' + info[1] + '">More Info</span>');
          });
        })

        $('.tooltip').tooltipster({
          theme: 'tooltipster-borderless',
          maxWidth: 320
        });
      }
    },

    /**
     * Updates the DOM with Slick carousel attributes for product images
     */
    initCarousel: function(initialSlide) {
      var initialSlide = initialSlide | 0;
      $(selectors.productCarousel, this.$container).slick({ initialSlide: initialSlide });
    },

    /**
     * Handle click events from product images
     */
    initGallery: function(evt) {
      $(selectors.productThumbs, this.$container).attr({ 'data-fancybox': 'gallery' }).fancybox({
        loop: true,
        margin : [0, 0],
        baseClass: 'product__gallery',
        buttons: ['close']
      });
    },

    /**
     * Handle click events from product videos
     */
    initVideosGallery: function(evt) {
      $(selectors.productVideoLink, this.$container).attr({ 'data-fancybox': 'videos' }).fancybox({
        baseClass: 'product__gallery',
        buttons: ['close']
      });
    },

    initVideos: function(evt) {
      $(selectors.productVideo, this.$container).each($.proxy(function(i, el) {
        var provider = $(el).data('product-video-provider');
        if (provider == 'youtube') {
          this.getInfoFromYouTube(el);
        } else {
          this.getInfoFromVimeo(el);
        }
      }, this));
    },

    initEarImpressionId: function() {
      $idInput = $(selectors.earImpressionId, this.$container).find('input');
      $idInput.attr('required', 'required');
      var name = $idInput.attr('name');
      $(selectors.earImpressionIdTrigger, this.$container).change(function() {
        var $li = $(this).parent('li');
        var $nextli = $li.next();
        if(typeof $nextli.attr('data-ear-impression-id') !== 'undefined') {
          $idInput.attr({ name: name, required: 'required' });
          $(selectors.earImpressionId, this.$container).show();
        } else {
          $idInput.removeAttr('name').removeAttr('required');
          $(selectors.earImpressionId, this.$container).hide();
        }
      });
    },

    initSwatches: function() {
      var $swatches = $(selectors.swatches, this.$container);
      var totalSwatches = $swatches.length;
      var swatchesFilled = false;
      var swatchesFilledArray = [];
      for(i = 0; i < totalSwatches; i++) {
        swatchesFilledArray.push(false);
      }

      if(totalSwatches > 0) {
        var $swatchesMirror = $(selectors.swatchesMirror, this.$container);
        var $swatchesMirrorInput = $(selectors.swatchesMirrorInput, this.$container);

        if($swatchesMirror.length > 0) {
          $swatchesMirror.each(function(i, mirror) {
            var trigger = $('<span>All Colors</span>').addClass('product__swatches__trigger').insertBefore($(mirror));
            trigger.on('click', function() {
              $(this).next().toggle();
            })
          });

          $(selectors.swatchesMirrorInput, this.$container).change(function() {
            var name = $(this).attr('name').split('---').pop();
            var index = $swatchesMirror.find('input[name="' + $(this).attr('name') + '"]').index($(this));
            if (index > 5) {
              var value = $(this).val();
              var hex = ($(this).data('hex'));
              var $input = $swatches.find('input[name="' + name + '"]').first();
              $input.val(value);
              $input.next().find('span').css("background-color", hex);
              $input.prop('checked', true);
            } else {
              $swatches.find('input[name="' + name + '"]:eq(' + index + ')').prop('checked', true);
            }
            $swatches.find('input[name="' + name + '"]').trigger('change');
            $(this).parents(selectors.swatchesMirror).hide();
          });

          $(selectors.addToCart, this.$container).tooltipster({
            content: 'Please pick your ear molds color first',
            theme: 'tooltipster-borderless',
            trigger: 'custom'
          });

          var that = this;

          $(this.$container).on('click', selectors.addToCart, function(e) {
            e.preventDefault();
            $(selectors.addToCart, that.$container).tooltipster('open');

            setTimeout(function() {
              $(selectors.addToCart, that.$container).tooltipster('close');
            }, 2000);
          });

          $(selectors.swatchesInput, this.$container).change(function() {
            if(!swatchesFilled) {
              var index = $(selectors.swatches, that.$container).index($(this).parents(selectors.swatches));
              swatchesFilledArray[index] = true;
              swatchesFilledArray.some(function(el) {
                if(el === false) {
                  return true;
                } else if (swatchesFilledArray[swatchesFilledArray.length - 1] === el) {
                  swatchesFilled = true;
                  return false;
                }
              });

              if(swatchesFilled) {
                $(selectors.addToCart, that.$container).removeAttr('disabled');
                $(that.$container).off('click', selectors.addToCart);
              }
            }
          });
        }
      }
    },

    getInfoFromYouTube: function(el) {
      var videoId = $(el).data('product-video-id');
      var apiKey = 'AIzaSyD7478v8-lSYeZ1OEFQtm7yQy1ngt_AB30';
      $(el).find(selectors.productVideoThumb).find('img').attr('src', 'https://img.youtube.com/vi/' + videoId + '/0.jpg');
      $.get("https://www.googleapis.com/youtube/v3/videos?part=snippet&id=" + videoId + "&key=" + apiKey, function(data) {
        $(el).find(selectors.productVideoTitle).text(data.items[0].snippet.title);
      });
      $('body').trigger('resetNavLimit');
    },

    getInfoFromVimeo: function(el) {
      var videoId = $(el).data('product-video-id');
      $.get( "https://vimeo.com/api/v2/video/" + videoId + ".json", function(data) {
        $(el).find(selectors.productVideoThumb).find('img').attr('src', data[0].thumbnail_large);
        $(el).find(selectors.productVideoTitle).text(data[0].title);
      });
      $('body').trigger('resetNavLimit');
    },

    /**
     * Handle click events on tabs
     */
    bindTabsEvents: function() {
      var $tabs = $(selectors.tabs);

      $tabs.each(function(i, tabs) {
        var $nav = $tabs.find(selectors.tabsNav);
        var $content = $tabs.find(selectors.tabsContent);

        $nav.find(':first-child').addClass('product__tab-label--active');
        $content.find('> li:first-child').addClass('product__tab--active');

        if ($nav.children().length > 1) {
          $nav.find('li').on('click', function(e) {
            var index = $(this).index();
            $nav.find('li').removeClass('product__tab-label--active');
            $nav.find('li:eq( ' + index + ' )').addClass('product__tab-label--active');
            $content.find('li').removeClass('product__tab--active');
            $content.find('li:eq( ' + index + ' )').addClass('product__tab--active');
          });
        }
      });
    },

    bindVariantPricing: function() {
      var obj = {};
      obj.variant = {};
      this.$container.on('variantPriceChange' + this.namespace, (function(evt) {
        obj.variant.price = evt.variant.price * this.multiplier;
        this.updateProductPrices(obj);
        this.currentPrice = obj.variant.price;
      }).bind(this));
    },

    /**
     * Handle Addons Pricing
     */

     bindCheckboxPrices: function() {
      var obj = {};
      obj.variant = {};
      var checkboxAddons = $(selectors.productAddons).find('input:checkbox');

      $.each(checkboxAddons, $.proxy(function(index, input) {
        if($(input).is(':checked')) {
          obj.variant.price = this.currentPrice + (parseInt($el.attr('data-option-price')) * this.multiplier);
          this.updateProductPrices(obj);
          this.currentPrice = obj.variant.price;
        }
      }, this));

      $(checkboxAddons).change($.proxy(function(evt) {
        var $el = $(evt.target);
        if ($el.is(':checked')) {
          obj.variant.price = this.currentPrice + (parseInt($el.attr('data-option-price')) * this.multiplier);
        } else {
          obj.variant.price = this.currentPrice - (parseInt($el.attr('data-option-price')) * this.multiplier);
        }
        this.updateProductPrices(obj);
        this.currentPrice = obj.variant.price;
      }, this));
     },

     bindRadioPrices: function() {
      var lastRadioPrices = {};
      var obj = {};
      obj.variant = {};
      var radioAddons = $(selectors.productAddons).find('input:radio');

      $.each(radioAddons, $.proxy(function(index, input) {
        if($(input).is(':checked')) {
          var key = $(input).attr('name');
          var newPrice = 0;
          if (typeof $(input).attr('data-option-price') !== 'undefined') {
            newPrice = parseInt($(input).attr('data-option-price'));
          }

          obj.variant.price = this.currentPrice + newPrice * (this.multiplier);
          this.updateProductPrices(obj);
          this.currentPrice = obj.variant.price;
          lastRadioPrices[key] = newPrice;
        }
      }, this));

      $(radioAddons).change($.proxy(function(evt) {
        var key = $(evt.target).attr('name');
        var oldPrice = lastRadioPrices[key] || 0;
        var newPrice = 0;
        if (typeof $(evt.target).attr('data-option-price') !== 'undefined') {
          newPrice = parseInt($(evt.target).attr('data-option-price'));
        }
        obj.variant.price = this.currentPrice + (newPrice * this.multiplier) - (oldPrice * this.multiplier);
        this.updateProductPrices(obj);
        this.currentPrice = obj.variant.price;
        lastRadioPrices[key] = newPrice;

        if ($(evt.target).attr('name') == 'properties[Rental Type]') {
          var addons = $(selectors.productAddons).find('input:radio[name!="properties[Rental Type]"]');
          $.each(addons, $.proxy(function(index, input) {
            if($(input).is(':checked')) {
              var name = $(input).attr('name');
              var newPrice = 0;
              if (typeof $(input).attr('data-option-price') !== 'undefined') {
                newPrice = parseInt($(input).attr('data-option-price'));
              }

              if(name == '') {
                obj.variant.price = this.currentPrice + (newPrice * this.multiplier);
              } else {
                obj.variant.price = this.currentPrice - (newPrice * this.multiplier);
              }
              this.updateProductPrices(obj);
              this.currentPrice = obj.variant.price;
            }
          }, this));
        }
      }, this));
     },

     bindSelectPrices: function() {
      var lastSelectPrices = {};
      var obj = {};
      obj.variant = {};
      var selectAddons = $(selectors.productAddons).find('select');

      $.each(selectAddons, $.proxy(function(index, select) {
        var key = $(select).attr('name');
        var selectedOption = $(select).find(':selected');
        var newPrice = 0;
        if (typeof $(selectedOption).attr('data-option-price') !== 'undefined') {
          newPrice = parseInt($(selectedOption).attr('data-option-price'));
        }
        obj.variant.price = this.currentPrice + (newPrice * this.multiplier);
        this.updateProductPrices(obj);
        this.currentPrice = obj.variant.price;
        lastSelectPrices[key] = newPrice;
      }, this));

      $(selectAddons).change($.proxy(function(evt) {
        var key = $(evt.target).attr('name');
        var selectedOption = $(evt.target).find(':selected');
        var oldPrice = lastSelectPrices[key] || 0;
        var newPrice = 0;
        if (typeof $(selectedOption).attr('data-option-price') !== 'undefined') {
          newPrice = parseInt($(selectedOption).attr('data-option-price'));
        }
        obj.variant.price = this.currentPrice + (newPrice * this.multiplier) - (oldPrice * this.multiplier);
        this.updateProductPrices(obj);
        this.currentPrice = obj.variant.price;
        lastSelectPrices[key] = newPrice;
      }, this));
    },

    bindQuantityPricing: function() {
      var qtySelect = $(selectors.productQtySelect);
      $(qtySelect).change($.proxy(function(evt) {
        var oldMultiplier = this.multiplier;
        this.multiplier = parseInt($(evt.target).find(':selected').val());
        var obj = {};
        obj.variant = {};
        obj.variant.price = this.currentPrice / oldMultiplier * this.multiplier;
        this.updateProductPrices(obj);
        this.currentPrice = obj.variant.price;
        $(selectors.productQtySelect).val(this.multiplier);
      }, this));
    },

    initDevices: function() {
      var customerId = $(selectors.devices).data('customer-id');
      var createdAt = $(selectors.devices).data('created-at');
      var expiresAt = $(selectors.devices).data('expires-at');
      var signature = $(selectors.devices).data('signature');
      var price = $(selectors.devices).data('current-variant-price');

      $.ajax({
        url: '/a/re/customer_devices',
        type: 'GET',
        data: {
          "customer_id": customerId,
          "_ls_created_at": createdAt,
          "_ls_expires_at": expiresAt,
          "_ls_signature": signature
        },
        success: function(response) {
          response.forEach(function(device, i) {
            var $li = $('<li class="reform__field is-super"></li>');
            $li.append('<input type="checkbox" id="device_' + i + '" name="' + device.serial_number + '" value="true" data-activation-device />');
            $li.append('<label for="device_' + i + '"><span class="is-value">' + device.nickname + '</span><span class="is-price">' + price + '</span></label>');
            $(selectors.devices).find('ul').append($li);
          })
        },
        error: function() {
          console.log('not working');
        }
      });

      this.bindActivationDevices();
    },

     /**
     * Handle Activation devices selection
     */

     bindActivationDevices: function() {
      var selectedDevices = [];
      var $quantity = $(selectors.activationQuantity);

      if (parseInt($quantity.val()) < 1) {
        $(selectors.addToCart).attr('disabled', true);
      }

      $(this.$container).on('change', selectors.activationDevice, function() {
        var serialNumber = $(this).attr('name');
        var qty = parseInt($quantity.val());
        if (this.checked) {
          selectedDevices.push(serialNumber);
          $quantity.val(qty + 1);
        } else {
          var index = selectedDevices.indexOf(serialNumber);
          if (index > -1) {
            selectedDevices.splice(index, 1);
          }
          $quantity.val(qty - 1);
        }

        if (parseInt($quantity.val()) < 1) {
          $(selectors.addToCart).attr('disabled', true);
        } else {
          $(selectors.addToCart).removeAttr('disabled');
        }
      });

      $(selectors.productForm).on('submit', function(e) {
        selectedDevices.forEach(function(device, i) {
          var $input = $('<input />')
            .attr('type', 'hidden')
            .attr('name', 'properties[Activation Device ' + (i+1) + ']')
            .val(device);
          $(selectors.productForm).append($input);
        })
      });
     },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Product;
})();

/**
 * Slideshow Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Slideshow template.
 *
   * @namespace product
 */

theme.Slideshow = (function() {
  /**
   * Slideshow section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Slideshow(container) {
    this.$container = $(container);
    var sectionId = this.$container.attr('data-section-id');

    this.settings = {};
    this.namespace = '.slideshow';

    this.initSlideshow();
  }

  Slideshow.prototype = $.extend({}, Slideshow.prototype, {
    /**
     * Updates the DOM with Slick carousel attributes for slideshow elements
     */
    initSlideshow: function() {
      $(this.$container).slick({
        arrows: false,
        dots: true,
        dotsClass: 'slide__dots'
      });
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Slideshow;
})();

/**
 * Rentals Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Rentals and Activations sections.
 *
   * @namespace races
 */

theme.Races = (function() {

  var selectors = {
    activationDevice: '[data-activation-device]',
    multiple: '[data-multiple]',
    multipleAction: '[data-multiple-action]',
    multipleDevices: '[data-multiple-devices]',
    multipleRace: '[data-multiple-race]',
    sectionContent: '[data-race-content]',
    sectionToggle: '[data-race-toggle]'
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Races(container) {
    this.$container = $(container);
    var sectionId = this.$container.attr('data-section-id');

    this.settings = {};
    this.namespace = '.races';

    this.multipleQueue = [];

    this.$container.addClass('is-accordion');
    this.initAccordion();
    this.initMultiple();
  }

  Races.prototype = $.extend({}, Races.prototype, {

    /**
     * Handles accordion on sections
     */
    initAccordion: function() {
      $(selectors.sectionToggle).click(function() {
        var content = $(this).next(selectors.sectionContent);
        $('body').trigger('resetNavLimit');
        if($(content).find('ul li').length > 0) {
          $(this).toggleClass('is-closed');
          $(content).toggle();
        }
      });
    },

    initMultiple: function() {
      var context = this;
      $(selectors.multiple).hide();
      $(selectors.multipleDevices).hide();

      $(selectors.multipleRace).change(function(e) {
        if ($(this).is(':checked')) {
          $(selectors.multiple).show();
        } else {
          $(selectors.multipleRace).each(function() {
            if($(this).is(':checked')) {
              $(selectors.multiple).show();
              return false;
            } else {
              $(selectors.multiple).hide();
            }
          })
        }
      });

      $(selectors.multipleAction).click($.proxy(function(e) {
        e.preventDefault();
        var $el = $(e.target);
        if($(selectors.multipleDevices).is(":visible")) {
          if (!$el.is(':disabled')) {
            context.addRacesToCart();
          }
        } else {
          this.getDevices();
          $(selectors.multipleDevices).show();
          $(selectors.multipleAction).attr('disabled', true).text('Activate Selected Devices');
        }
      }, this));

      $(this.$container).on('change', selectors.activationDevice, function(e) {
        if ($(this).is(':checked')) {
          $(selectors.multipleAction).removeAttr('disabled');
        } else {
          $(selectors.activationDevice).each(function() {
            if($(this).is(':checked')) {
              $(selectors.multipleAction).removeAttr('disabled');
              return false;
            } else {
              $(selectors.multipleAction).attr('disabled', true);
            }
          })
        }
      });
    },

    getDevices: function() {
      var customerId = $(selectors.multiple).data('customer-id');
      var createdAt = $(selectors.multiple).data('created-at');
      var expiresAt = $(selectors.multiple).data('expires-at');
      var signature = $(selectors.multiple).data('signature');

      $.ajax({
        url: '/a/re/customer_devices',
        type: 'GET',
        data: {
          "customer_id": customerId,
          "_ls_created_at": createdAt,
          "_ls_expires_at": expiresAt,
          "_ls_signature": signature
        },
        success: function(response) {
          response.forEach(function(device, i) {
            var $li = $('<li class="reform__field is-super"></li>');
            $li.append('<input type="checkbox" id="device_' + i + '" name="' + device.serial_number + '" value="true" data-activation-device />');
            $li.append('<label for="device_' + i + '"><span class="is-value">' + device.nickname + '</span></label>');
            $(selectors.multipleDevices).find('ul').append($li);
          })
        },
        error: function() {
          console.log('not working');
        }
      });
    },

    addRacesToCart: function() {
      var context = this;
      var properties = {};
      var quantity = 0;
      $(selectors.activationDevice).filter(':checked').each(function(i) {
        properties['Activation Device ' + (i+1)] = $(this).attr('name');
        properties['_type'] = 'Activation';
        quantity++;
      });

      $(selectors.multipleRace).filter(':checked').each(function() {
        context.multipleQueue.push({
          id: parseInt($(this).attr('name')),
          quantity: quantity,
          properties: properties
        });
      });
      $(selectors.multipleAction).attr('disabled', true).text('Adding Races...');
      this.moveAlongQueue();
    },

    moveAlongQueue: function() {
      // If we still have requests in the queue, let's process the next one.
      var context = this;
      if (this.multipleQueue.length) {
        var request = this.multipleQueue.shift();
        $.ajax({
          method: 'POST',
          url: '/cart/add.js',
          data: request,
          dataType: 'json',
          success: function() {
            context.moveAlongQueue();
          },
          error: function() {
            $(selectors.multipleAction).text('Activate Selected Devices');
          }
        });
      }
      // If the queue is empty, we will redirect to the cart page.
      else {
        document.location.href = '/cart';
      }
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Races;
})();

/**
 * Update Device Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Update Device section.
 *
 */

theme.UpdateDevice = (function() {

  var selectors = {
    os: '[data-os]',
    osNavItem: '[data-os-nav-item]',
    step: '[data-step]',
    stepNavItem: '[data-step-nav-item]',
    stepNavNext: '[data-step-nav-next]',
    stepNavPrev: '[data-step-nav-prev]'
  };
  /**
   * Update Device section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function UpdateDevice(container) {
    this.$container = $(container);
    var sectionId = this.$container.attr('data-section-id');

    this.settings = {};
    this.namespace = '.update-device';

    this.currentOs = 'win';
    this.currentStep = 1;
    this.totalSteps = 5;

    this.initOS();
    this.initSteps();
  }

  UpdateDevice.prototype = $.extend({}, UpdateDevice.prototype, {
    initOS: function() {
      $(selectors.osNavItem).on('click', $.proxy(function(e) {
        var $el = $(e.target);
        if($el.is('img')) {
          $el = $el.parent('li')
        }
        var goToOs = $el.data('go-to-os');
        $(selectors.os).hide();
        $(selectors.os).filter('[data-os-name="' + goToOs + '"]').show();
        $(selectors.osNavItem).removeClass('is-active');
        $el.addClass('is-active');
        this.currentOs = goToOs;
      }, this));
    },
    initSteps: function() {
      $(selectors.stepNavItem).on('click', $.proxy(function(e) {
        var $el = $(e.target);
        var goToStep = $el.data('go-to-step');
        $(selectors.step).hide();
        $(selectors.step).filter('[data-step-number="' + goToStep + '"]').show();
        $(selectors.stepNavItem).removeClass('is-active');
        $el.addClass('is-active');
        this.currentStep = parseInt(goToStep);
        if(this.currentStep == this.totalSteps) {
          $(selectors.stepNavNext).addClass('is-disabled');
        } else if (this.currentStep == 1) {
          $(selectors.stepNavPrev).addClass('is-disabled');
        } else {
          $(selectors.stepNavPrev).removeClass('is-disabled');
          $(selectors.stepNavNext).removeClass('is-disabled');
        }
      }, this));

      $(selectors.stepNavNext).on('click', $.proxy(function(e) {
        if(this.currentStep < this.totalSteps) {
          var goToStep = this.currentStep + 1;
          $(selectors.step).hide();
          $(selectors.step).filter('[data-step-number="' + goToStep + '"]').show();
          $(selectors.stepNavItem).removeClass('is-active');
          $(selectors.stepNavItem).filter('[data-go-to-step="' + goToStep + '"]').addClass('is-active');
          this.currentStep = goToStep;
          if(this.currentStep == this.totalSteps) {
            $(selectors.stepNavNext).addClass('is-disabled');
          } else if (this.currentStep == 1) {
            $(selectors.stepNavPrev).addClass('is-disabled');
          } else {
            $(selectors.stepNavPrev).removeClass('is-disabled');
            $(selectors.stepNavNext).removeClass('is-disabled');
          }
        }
      }, this));

      $(selectors.stepNavPrev).on('click', $.proxy(function(e) {
        if(this.currentStep > 1) {
          var goToStep = this.currentStep - 1;
          $(selectors.step).hide();
          $(selectors.step).filter('[data-step-number="' + goToStep + '"]').show();
          $(selectors.stepNavItem).removeClass('is-active');
          $(selectors.stepNavItem).filter('[data-go-to-step="' + goToStep + '"]').addClass('is-active');
          this.currentStep = goToStep;
          if(this.currentStep == this.totalSteps) {
            $(selectors.stepNavNext).addClass('is-disabled');
          } else if (this.currentStep == 1) {
            $(selectors.stepNavPrev).addClass('is-disabled');
          } else {
            $(selectors.stepNavPrev).removeClass('is-disabled');
            $(selectors.stepNavNext).removeClass('is-disabled');
          }
        }
      }, this));
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return UpdateDevice;
})();


/*================ Templates ================*/
/**
 * Cart Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart
 * template.
 *
 * @namespace cart
 */

theme.cart = (function() {

  var selectors = {
    cart: '[data-cart]',
    cartCount: '[data-cart-count]',
    cartItem: '[data-cart-item]',
    cartItemQty: '[data-cart-item-qty]',
    cartItemSubtotal: '[data-cart-item-subtotal]',
    cartItemTotal: '[data-cart-item-total]',
    cartTotal: '[data-cart-total]'
  };

  if (!$(selectors.cart).length) {
    return;
  }

  // $.post('/cart/clear.js');

  var cartTotal;
  var cartItems = [];
  var multipleQueue = [];

  $(selectors.cartItemQty).on('change', function() {
    var el = $(this).parents(selectors.cartItem);
    var data = {
      id: $(el).attr('data-cart-item-id'),
      line: $(selectors.cartItem).index(el) + 1,
      ref: $(el).attr('data-product-customizer-pricing-ref'),
      parent: $(el).is('[data-cart-item-parent]'),
      qty: parseInt($(el).attr('data-cart-item-quantity')),
      newQty: parseInt($(this).val())
    };

    $(el).attr('data-cart-item-quantity', data.newQty);
    updateQty(data);
  });

  var updateQty = function(data) {
    multipleQueue.push(data);
    moveAlongQueue();
  };

  var moveAlongQueue = function() {
    if (multipleQueue.length) {
      var request = multipleQueue.shift();
      data = { quantity: request.newQty };
      if (request.parent || request.forceId) {
        data.id = request.id;
      } else {
        data.line = request.line;
      }
      
      $.ajax({
        method: 'POST',
        url: '/cart/change.js',
        data: data,
        dataType: 'json',
        success: function(data) {
          if (request.newQty === 0) {
            $(selectors.cartItem).filter('[data-cart-item-id="' + request.id + '"]').remove();
            $(selectors.cartItem).filter('[data-product-customizer-pricing-ref="' + request.ref + '"][data-cart-item-id!="' + request.id + '"]').each(function() {
              multipleQueue.push({
                line: $(selectors.cartItem).index(this) + 1,
                newQty: 0,
                parent: false
              });
              $(this).remove();
            });
          } else {
            if(request.parent) {  
              $(selectors.cartItem).filter('[data-product-customizer-pricing-ref="' + request.ref + '"][data-cart-item-id!="' + request.id + '"]').each(function() {
                var input = $(this).find(selectors.cartItemQty);
                var multiplier = parseInt($(input).val()) / request.qty;
                $(input).val(multiplier * request.newQty);
                $(input).trigger('change');
              });
            }
          }

          cartItems = data.items;
          cartTotalPrice = data.total_price;
          cartTotalCount = data.item_count;
          moveAlongQueue();
        },
        error: function() {}
      });
    } else {
      updateInfo();
    }
  };

  var updateInfo = function() {
    if (cartItems.length === 0) {
      location.reload();
    } else {
      cartItems.forEach(function(item) {
        var itemPrice = item.line_price;
        if (item.properties != null && item.properties._pc_pricing_ref && item.properties._pc_pricing_qty) {
          cartItems.forEach(function(otherItem) {
            if (otherItem.properties != null && typeof otherItem.properties._pc_pricing_qty === 'undefined' && otherItem.properties._pc_pricing_ref === item.properties._pc_pricing_ref) {
              itemPrice += otherItem.line_price;
            }
          });
        }

        $(selectors.cartItem).filter('[data-cart-item-id="' + item.id + '"]')
          .find(selectors.cartItemSubtotal)
          .html(slate.Currency.formatMoney(itemPrice, theme.moneyFormat));

        if (item.properties != null && item.properties._pc_pricing_ref && typeof item.properties._pc_pricing_qty === 'undefined') {
          cartTotalCount = cartTotalCount - item.quantity;
        }
      });

      $(selectors.cartTotal).html(slate.Currency.formatMoney(cartTotalPrice, theme.moneyFormat));
      $(selectors.cartCount).html(cartTotalCount);
    }
  }

})();

/**
 * Collection Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Collection template.
 *
 * @namespace collection
 */

theme.collection = (function() {
  var config = {
    sortBy: '#SortBy',
    collectionHero: '#CollectionHero'
  };

  var queryParams = {};
  initParams();
  initCollectionHero();

  var defaultSortBy = $(config.sortBy).data("sort-by-active");
  $(config.sortBy).val(defaultSortBy).on('change', onChangeSortBy);

  function initParams() {
    if (location.search.length) {
      for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
        aKeyValue = aCouples[i].split('=');
        if (aKeyValue.length > 1) {
          queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
        }
      }
    }
  }

  function initCollectionHero() {
    $(config.collectionHero).slick({
      arrows: false,
      dots: true,
      dotsClass: 'collection-hero__dots'
    });
  }

  function onChangeSortBy(e) {
    e.preventDefault();
    queryParams.sort_by = $(this).val();
    location.search = $.param(queryParams).replace(/\+/g, '%20');
  }
})();

/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Account
 * template.
 *
 * @namespace customerAccount
 */

theme.customerAccount = (function() {

  var selectors = {
    customerAccount: '[data-customer-account]'
  };

  var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = decodeURIComponent(window.location.search.substring(1)),
      sURLVariables = sPageURL.split('&'),
      sParameterName,
      i;

    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split('=');
      if (sParameterName[0] === sParam) {
        return sParameterName[1] === undefined ? true : sParameterName[1];
      }
    }
  };

  if(typeof getUrlParameter('preset') !== 'undefined') {
    var $message = $('<div class="account__message is-positive">Check your email in order to reset your password!</div>');
    $(selectors.customerAccount).prepend($message);
  }

})();

/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {

  var selectors = {
    newAddressForm: '[data-new-address-form]',
    newAddressOn: '[data-new-address-on]',
    newAddressOff: '[data-new-address-off]',
    editAddressForm: '[data-edit-address-form]',
    editAddressOn: '[data-edit-address-on]',
    editAddressOff: '[data-edit-address-off]',
    deleteAddress: '[data-delete-address]'
  };

  if (!$(selectors.newAddressForm).length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $(selectors.newAddressOn).on('click', function() {
    $(selectors.newAddressOn).hide();
    $(selectors.newAddressForm).show();
    $(selectors.newAddressForm).find('*').filter(':input:visible:first').focus();
  });

  $(selectors.newAddressOff).on('click', function() {
    $(selectors.newAddressOn).show();
    $(selectors.newAddressForm).hide();
  });

  $(selectors.editAddressOn).on('click', function() {
    $(selectors.editAddressForm).hide();
    var id = $(this).data('id');
    var $form = $(selectors.editAddressForm + '[data-id="' + id + '"]');
    $form.show();
    $form.find('*').filter(':input:visible:first').focus();
  });

  $(selectors.editAddressOff).on('click', function() {
    $(selectors.editAddressForm).hide();
  });

  $(selectors.deleteAddress).on('click', function() {
    var id = $(this).data('id');
    var confirmMessage = $(this).data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + id, {parameters: {_method: 'delete'}});
    }
  });

})();

/**
 * Customer Bundles Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Bundles
 * template.
 *
 * @namespace customerBundles
 */

theme.customerBundles = (function() {

  var selectors = {
    bundles: '[data-bundles]',
    bundlesCreditsLeft: '[data-bundles-credits-left]',
    bundlesDevices: '[data-bundles-devices]',
    bundlesForm: '[data-bundles-form]',
  };

  var customerId = $(selectors.bundles).data('customer-id');
  var createdAt = $(selectors.bundles).data('created-at');
  var expiresAt = $(selectors.bundles).data('expires-at');
  var signature = $(selectors.bundles).data('signature');
  var creditsLeft = 0;
  var $form = $(selectors.bundlesForm);

  if (!$(selectors.bundles).length) {
    return;
  }

  $.ajax({
    url: '/a/re/customer_devices',
    type: 'GET',
    data: {
      "customer_id": customerId,
      "_ls_created_at": createdAt,
      "_ls_expires_at": expiresAt,
      "_ls_signature": signature
    },
    success: function(response) {
      response.forEach(function(device) {
        $form.find(selectors.bundlesDevices).append('<option value="' + device.serial_number + '">' + device.nickname + '</option>');
      });
    },
    error: function() {
      console.log('not working');
    }
  });

  $.ajax({
    url: '/a/re/activation_bundles',
    type: 'GET',
    data: {
      "customer_id": customerId,
      "_ls_created_at": createdAt,
      "_ls_expires_at": expiresAt,
      "_ls_signature": signature
    },
    success: function(response) {
      response.forEach(function(bundle) {
        creditsLeft += bundle.credits_left;
        var date = new Date(bundle.added_at * 1000);
        var bundle_year = date.getFullYear();
        var bundle_month = date.getMonth();
        var bundle_day = date.getDate();
        var bundle_date = bundle_month + '/' + bundle_day + '/' + bundle_year;
        var $tr = $('<tr class="responsive-table-row"></tr>');
        $tr.append('<td data-label="Order ID">' + bundle.order_id + '</td>');
        $tr.append('<td data-label="Season">' + bundle.season + '</td>');
        $tr.append('<td data-label="Credits Purchased">' + bundle.credits_purchased + '</td>');
        $tr.append('<td data-label="Price">$' + bundle.price + '</td>');
        $tr.append('<td data-label="Date">' + bundle_date + '</td>');
        $(selectors.bundles).find('table tbody').append($tr);
      });

      $(selectors.bundlesCreditsLeft).text(creditsLeft);
      if(creditsLeft > 0) {
        $form.find('button').removeAttr('disabled');
      }
      $(selectors.bundles).show();
    },
    error: function() {
      console.log('not working');
    }
  });

  $(selectors.bundles).on('submit', selectors.bundlesForm, function(e) {
    e.preventDefault();
    var $form = $(this);
    $form.find('button:submit').attr('disabled', true);
    $form.find('.reform__message').hide();
    $.ajax({
      url: $form.attr('action'),
      type: $form.attr('method'),
      data: $form.serialize(),
      success: function(response) {
        var message = "You have successfully activated your device for this race!";
        $form.find('.reform__message').text(message).addClass('is-success').show();
        setTimeout(function() {
          window.location.reload();
        }, 2500);
      },
      error: function(xhr, status, error) {
        var message = JSON.parse(xhr.responseText);
        var error = message.errors.pop();
        if (error == "season_not_found") {
          message = "We couldn’t find the season. Make sure it's still available and try again. If you think this is an error, please contact us at support@racingelectronics.com.";
        } else if (error == "device_not_found") {
          message = "We couldn’t find this device on your list of owned devices. If you think this is an error, please contact us at support@racingelectronics.com.";
        } else if (error == "valid_bundle_not_found") {
          message = "We couldn’t find this race on the list of valid races for current season. If you think this is an error, please contact us at support@racingelectronics.com.";
        }
        $form.find('.reform__message').text(message).addClass('is-error').show();
        $form.find('button:submit').removeAttr('disabled');
      }
    });
  })
})();

/**
 * Customer Details Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Details
 * template.
 *
 * @namespace customerDetails
 */

theme.customerDetails = (function() {

  var selectors = {
    detailsForm: '[data-account-details-form]',
  };

  if (!$(selectors.detailsForm).length) {
    return;
  }

  $(selectors.detailsForm).find('form').on('submit', function(e) {
    e.preventDefault();
    var $form = $(this);
    $form.find('button:submit').attr('disabled', true);
    $.ajax({
      url: $form.attr('action'),
      type: $form.attr('method'),
      data: $form.serialize(),
      success: function(response) {
        $form.find('.reform__content').prepend('<div class="reform__message is-success">Your details have been updated!</div>');
        setTimeout(function() {
          window.location.reload();
        }, 1500);
      },
      error: function() {
        $form.find('button:submit').removeAttr('disabled');
      }
    });
  });

})();

/**
 * Customer Devices Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Device
 * template.
 *
 * @namespace customerDevices
 */

theme.customerDevices = (function() {

  var selectors = {
    devices: '[data-devices]',
    devicesList: '[data-devices-list]',
    newDeviceForm: '[data-new-device-form]',
    newDeviceOn: '[data-new-device-on]',
    newDeviceOff: '[data-new-device-off]',
    deleteDevice: '[data-delete-device]'
  };

  if (!$(selectors.newDeviceForm).length || !$(selectors.devices).length) {
    return;
  }

  var customerId = $(selectors.devices).data('customer-id');
  var createdAt = $(selectors.devices).data('created-at');
  var expiresAt = $(selectors.devices).data('expires-at');
  var signature = $(selectors.devices).data('signature');

  $.ajax({
    url: '/a/re/customer_devices',
    type: 'GET',
    data: {
      "customer_id": customerId,
      "_ls_created_at": createdAt,
      "_ls_expires_at": expiresAt,
      "_ls_signature": signature
    },
    success: function(response) {
      response.forEach(function(device) {
        var $li = $('<li class="account__devices__item"></li>');
        var $data = $('<div class="is-data"></div>');
        $data.append('<div><span class="is-label">Serial Number:</span> ' + device.serial_number + '</div>');
        $data.append('<div><span class="is-label">Nickname:</span> ' + device.nickname + '</div>');
        $li.append($data);
        if (device.activated_events.length > 0) {
          var $races = $('<div class="is-races"></div>');
          var $racesList = $('<ul></ul>');
          device.activated_events.forEach(function(race) {
            $racesList.append('<li>' + race.name + ' <span class="is-date">' + race.date + '</span>');
          })
          $races.append($racesList);
          $li.append($races);
        }

        var $actions = $('<div class="is-actions"></div>');
        $actions.append('<button type="button" data-delete-device data-id="' + device.serial_number + '" data-confirm-message="Are you sure you want to delete this device?"><span>Delete</span></button>')
        $li.append($actions);

        $(selectors.devicesList).append($li);
      })
    },
    error: function() {
      console.log('not working');
    }
  });

  $(selectors.newDeviceOn).on('click', function() {
    $(selectors.newDeviceOn).hide();
    $(selectors.newDeviceForm).show();
    $(selectors.newDeviceForm).find('*').filter(':input:visible:first').focus();
  });

  $(selectors.newDeviceOff).on('click', function() {
    $(selectors.newDeviceOn).show();
    $(selectors.newDeviceForm).hide();
  });

  $(selectors.newDeviceForm + ',' + selectors.editDeviceForm).find('form').on('submit', function(e) {
    e.preventDefault();
    var $form = $(this);
    $form.find('button:submit').attr('disabled', true);
    $form.find('.reform__message').hide();
    $.ajax({
      url: $form.attr('action'),
      type: $form.attr('method'),
      data: $form.serialize(),
      success: function(response) {
        window.location.reload();
      },
      error: function(xhr, status, error) {
        var message = JSON.parse(xhr.responseText);
        var error = message.errors.base.pop();
        if (error == "Device is already registered") {
          error = "This device is already registered and can’t be added to your account. If it belongs to you and you think this is an error, please contact us at support@racingelectronics.com.";
        } else if (error == "Couldn't find this device") {
          error = "We could not find this device’s serial number on our database. If you think this is an error, please contact us at support@racingelectronics.com.";
        }
        $form.find('.reform__message').text(error).addClass('is-error').show();
        $form.find('button:submit').removeAttr('disabled');
      }
    });
  });

  $(selectors.devicesList).on('click', selectors.deleteDevice, function() {
    var confirmMessage = $(this).data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      var id = $(this).data('id');
      $.ajax({
        url: "/a/re/customer_devices/" + id,
        type: "DELETE",
        data: {
          "customer_id": customerId,
          "_ls_created_at": createdAt,
          "_ls_expires_at": expiresAt,
          "_ls_signature": signature
        },
        success: function(response) {
          window.location.reload();
        },
        error: function(response) {
          console.log(response);
        }
      });
    }
  });

})();

/**
 * Customer Devices Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Device
 * template.
 *
 * @namespace customerGiftCardBalance
 */

theme.customerGiftCardBalance = (function() {

  var selectors = {
    giftCardBalance: '[data-gift-card-balance]'
  };

  if (!$(selectors.giftCardBalance).length) {
    return;
  }

  var customerId = $(selectors.giftCardBalance).data('customer-id');
  var createdAt = $(selectors.giftCardBalance).data('created-at');
  var expiresAt = $(selectors.giftCardBalance).data('expires-at');
  var signature = $(selectors.giftCardBalance).data('signature');

  $.ajax({
    url: '/a/re/gift_cards',
    type: 'GET',
    data: {
      "customer_id": customerId,
      "_ls_created_at": createdAt,
      "_ls_expires_at": expiresAt,
      "_ls_signature": signature
    },
    success: function(response) {
      response.forEach(function(giftCard) {
        var $tr = $('<tr class="responsive-table-row"></tr>');
        $tr.append('<td data-label="Gift Card Number">**** ' + giftCard.last_characters + '</td>');
        $tr.append('<td data-label="Initial Value">$' + giftCard.initial_value + '</td>');
        $tr.append('<td data-label="Balance">$' + giftCard.balance + '</td>');
        $tr.append('<td data-label="Balance">' + (giftCard.expires_on ? giftCard.expires_on : '-')  + '</td>');
        $(selectors.giftCardBalance).find('table tbody').append($tr);
      })
    },
    error: function() {
      console.log('not working');
    }
  });

  $(selectors.newDeviceOn).on('click', function() {
    $(selectors.newDeviceOn).hide();
    $(selectors.newDeviceForm).show();
    $(selectors.newDeviceForm).find('*').filter(':input:visible:first').focus();
  });

  $(selectors.newDeviceOff).on('click', function() {
    $(selectors.newDeviceOn).show();
    $(selectors.newDeviceForm).hide();
  });

  $(selectors.newDeviceForm + ',' + selectors.editDeviceForm).find('form').on('submit', function(e) {
    e.preventDefault();
    var $form = $(this);
    $form.find('button:submit').attr('disabled', true);
    $.ajax({
      url: $form.attr('action'),
      type: $form.attr('method'),
      data: $form.serialize(),
      success: function(response) {
        window.location.reload();
      },
      error: function() {
        $form.find('button:submit').removeAttr('disabled');
      }
    });
  });

  $(selectors.editDeviceOn).on('click', function() {
    $(selectors.editDeviceForm).hide();
    var id = $(this).data('id');
    var $form = $(selectors.editDeviceForm + '[data-id="' + id + '"]');
    $form.show();
    $form.find('*').filter(':input:visible:first').focus();
  });

  $(selectors.editDeviceOff).on('click', function() {
    $(selectors.editDeviceForm).hide();
  });

  $(selectors.deleteDevice).on('click', function() {
    var confirmMessage = $(this).data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      var id = $(this).data('id');
      var $form = $(selectors.editDeviceForm + '[data-id="' + id + '"]').find('form');
      $.ajax({
        url: "/a/re/customer_devices/" + id,
        type: "DELETE",
        data: $form.serialize(),
        success: function(response) {
          window.location.reload();
        }
      });
    }
  });

})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();



/*================ Global ================*/
(function() {
  var login = document.querySelectorAll('[data-login-link]');
  var createAccount = document.querySelectorAll('[data-signup-link]');
  var overlay = document.querySelector('.modal-overlay')
  var modal = document.querySelector('.modal');
  var modalLoginBtn = document.querySelectorAll('[data-login-link-internal]');
  var modalRegisterBtn = document.querySelectorAll('[data-signup-link-internal]');
  var modalLogin = document.getElementById('login-modal-content');
  var modalRegister = document.getElementById('register-modal-content');
  var modalResetBtn = document.querySelectorAll('[data-reset-password]');
  var modalReset = document.getElementById('reset-modal-content');

  /**
   * Function handles reseting modal back to the original state when closing
   * the modal.
   * @return {void}
   */
  function removeModal() {
    modal.classList.remove( 'modal--show' );
    modalLogin.classList.remove( 'show' );
    modalRegister.classList.remove( 'show' );
    modalReset.classList.remove( 'show' );
  }

  /**
   * Function resets the overlay click events to ensure that users can exit the modal
   * by clicking anywhere outside of the modal.
   * @return {void}
   */
  function reset_overlay_listener() {
    overlay.removeEventListener( 'click', removeModal );
    overlay.addEventListener( 'click', removeModal );
  }

  /**
   * Function handles displaying the modal.
   * @return {void}
   */
  function displayModal() {
    modal.classList.add( 'modal--show' );
    modalLogin.classList.add( 'show' );
  }

  /**
   * Function handles finding the currently active modal content section. This is
   * used later to hide this section when showing a new section inside the modal
   * @return {Element|false} Returns a DOM Element if found.
   */
  function findCurrentActive() {
    var active = modal.querySelectorAll( '.show' );
    return ( active && 0 < active.length ) ? active[0] : false;
  }

  /**
   * Function registers an element as a modal click event. Function also handles
   * updating the modal state whenever this element is clicked.
   * @param  {Element} clickEl   The DOM Element which should trigger a modal change.
   * @param  {Element} section   The Modal section to show when clcikEl is clicked.
   * @param  {bool} showModal Whether we should show the the parent Modal.
   * @return {void|bool}  Function will return false if clickEl is undefined.
   */
  function register_modal_change( clickEl, section, showModal ) {
    if ( ! clickEl ) {
      return false;
    }

    els = Array.prototype.slice.call(clickEl,0); 

    els.forEach(function(el) {
      el.addEventListener( 'click', function(e) {
        e.preventDefault();
  
        if ( true === showModal ) {
          displayModal();
          reset_overlay_listener();
        }
  
        var activeModalEl = findCurrentActive();
  
        if ( activeModalEl ) {
          activeModalEl.classList.remove( 'show' );
        }
  
        section.classList.add( 'show' );
  
      });
    });
  }

  /**
   * Register all the modal Click Events.
   */
  register_modal_change( login, modalLogin, true );
  register_modal_change( createAccount, modalRegister, true );
  register_modal_change( modalLoginBtn, modalLogin, false );
  register_modal_change( modalRegisterBtn, modalRegister, false );
  register_modal_change( modalResetBtn, modalReset, false );

})();

/**
 * Search Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the search autocomplete
 * functionality.
 *
 * @namespace search
 */

theme.search = (function() {
    var selectors = {
        searchForm: '[data-search-form]'
    };

    if (!$(selectors.searchForm).length) {
        return;
    }

    var currentAjaxRequest;
    var resultsList = $('<ul class="is-results"></ul>').hide();
    var input = $(selectors.searchForm).find('input[name="q"]');

    $(selectors.searchForm).append(resultsList);

    input.attr('autocomplete', 'off').on('keyup change', function() {
        var term = $(this).val();
        var form = $(this).closest('form');
        var searchURL = '/search?type=product&q=' + term;

        if (term.length > 3 && term != $(this).data('old-term')) {
            $(this).data('old-term', term);

            if (currentAjaxRequest != null) currentAjaxRequest.abort();

            currentAjaxRequest = $.getJSON(searchURL + '&view=json', function(data) {
                resultsList.empty();
                if(data.results_count == 0) {
                    resultsList.hide();
                } else {
                    $.each(data.results, function(index, item) {
                        var link = $('<a></a>').attr('href', item.url);
                        link.append('<span class="is-thumbnail"><img src="' + item.thumbnail + '" /></span>');
                        link.append('<span class="is-title">' + item.title + '</span>');
                        link.wrap('<li class="is-results-item"></li>');
                        resultsList.append(link.parent());
                    });

                    if(data.results_count > 10) {
                        resultsList.append('<li class="is-results-item is-all"><a href="' + searchURL + '"><span class="is-title">See all results (' + data.results_count + ')</span></a></li>');
                    }

                    resultsList.fadeIn(200);
                }
            });
        }
    })

    $('body').on('click', function() {
        $('.is-results').hide();
    });
})();
  
theme.shippingCalculator = (function() {
  var selectors = {
    action: '[data-shipping-action]',
    calculator: '[data-shipping-calculator]',
    calculatorContent: '[data-shipping-calculator-content]',
    calculatorTrigger: '[data-shipping-calculator-trigger]',
    countrySelect: '[data-shipping-country-select]',
    error: '[data-shipping-error]',
    form: '[data-shipping-form]',
    reform: '[data-shipping-reform]',
    results: '[data-shipping-results]',
    stateSelect: '[data-shipping-state-select]',
    zipcode: '[data-shipping-zipcode]',
  };

  if (!$(selectors.calculator).html()) {
    return;
  }

  var buttonDisabledText = $(selectors.action).data('label-disabled');
  var buttonActiveText = $(selectors.action).text();
  var defaultCountry = $(selectors.calculator).data('shipping-default-country');

  var fillStates = function(country) {
    $(selectors.stateSelect).empty();
    if (Countries[country].provinces && Countries[country].provinces.length > 0) {
      Countries[country].provinces.forEach(function(province) {
        $(selectors.stateSelect).append('<option value="' + province + '">' + province + '</option>');
      });
    }
  };

  var submitAddress = function(address) {
    $.ajax({
      url: '/cart/prepare_shipping_rates',
      type: 'POST',
      data: jQuery.param({
        shipping_address: address
      }),
      success: pollForCartShippingRates(address),
      error: onError
    });
  };

  var pollForCartShippingRates = function(address) {
    var t = function() {
      jQuery.ajax("/cart/async_shipping_rates", {
        dataType: "json",
        success: function(r, n, a) {
          200 === a.status ? renderShippingRate(r.shipping_rates) : setTimeout(t, 500);
        },
        error: onError
      });
    };

    return t;
  };

  var renderShippingRate = function(shippingRates) {
    if (shippingRates[0].name.startsWith('Order Pickup')) {
      shippingRates.shift();
    }
    
    var rate = getShippingRate(shippingRates);
    if(rate == 'free') {
      $(selectors.results).append('<span class="is-label">Shipping:</span>');
      $(selectors.results).append('<span class="is-value is-free">Free!</span>');
    } else {
      $(selectors.results).append('<span class="is-label">Estimated Shipping:</span>');
      $(selectors.results).append('<span class="is-value is-free">' + rate + '</span>');
    }
    $(selectors.form).hide();
    $(selectors.results).prepend('<button type="button" class="is-action" data-shipping-reform>Calculate Again</button>');
    $(selectors.action).text(buttonActiveText).removeAttr('disabled');

  }

  var getShippingRate = function(shippingRates) {
    if (shippingRates[0].price == '0.00') {
      return "free";
    }

    var rate = slate.Currency.formatMoney(shippingRates[0].price, theme.moneyFormat);
    if(shippingRates.length > 1) {
      rate = "Starting from " + rate;
    }

    return rate;
  };

  var fullMessagesFromErrors = function(e) {
    var t = [];
    return jQuery.each(e, function(e, r) {
      jQuery.each(r, function(r, n) {
        t.push(e + " " + n)
      })
    }), t
  };

  var onError = function(request) {
    var feedback = "";
    var data = eval("(" + request.responseText + ")");
    feedback = data.message ?  data.message + "(" + data.status + "): " + data.description : "Error: " + fullMessagesFromErrors(data).join("; ") + ".";
    if (feedback === "Error: country is not supported.") {
      feedback = "We do not ship to this destination."
    }
    $(selectors.error).html(feedback);
    $(selectors.action).text(buttonActiveText).removeAttr('disabled');
  };

  $(selectors.calculator).on('change', selectors.countrySelect, function() {
    var countryName = $(this).val();
    fillStates(countryName);
  });

  $(selectors.calculator).on('click', selectors.action, function(e) {
    e.preventDefault();
    $(this).text(buttonDisabledText).attr('disabled', true);
    submitAddress({
      country: $(selectors.countrySelect).val(),
      province: $(selectors.stateSelect).val(),
      zip: $(selectors.zipcode).val()
    });
    $(selectors.error).empty();
  });

  $(selectors.calculator).on('click', selectors.calculatorTrigger, function(e) {
    e.preventDefault();
    $(selectors.calculatorContent).show();
    $(this).hide();
  });

  $(selectors.calculator).on('click', selectors.reform, function(e) {
    e.preventDefault();
    $(selectors.form).show();
    $(selectors.results).empty();
  });

  $(selectors.calculator).on('keypress', selectors.form, function(e) {
    if (e.which === 13) {
      return false;
    }
  });

  fillStates(defaultCountry);

})();


/*================ Pages ================*/
(function() {
  var faqs = document.querySelectorAll('.faq__item');

  if (!faqs) {
    return false;
  }

  [].forEach.call( faqs, function( faq ) {
    faq.addEventListener( 'click', function(e) {
      faq.classList.toggle( 'show' );
    } );
  } );
})();

(function() {
  var searchInput = document.getElementById('manuals-search-input');

  if ( ! searchInput ) {
    return false;
  }

  var manualsList = getManualsList();
  var noResults = document.getElementById('manuals-no-results');

  searchInput.addEventListener('keyup', function(e) {
    updateManualList(e, manualsList, noResults);
  } );
})();

/**
 * Function handles showing and hiding the no result message, based on
 * whether or not we find any manuals matching the query.
 * @param  {Array} matches   An array of all matching Manuals
 * @param  {documentElement} noResults The wrapper element for the "No Results" message.
 * @return {void}
 */
function updateEmptyMessage(matches, noResults) {
  if (0 === matches.length) {
    noResults.classList.remove('hide');
  } else {
    noResults.classList.add('hide');
  }
}

/**
 * Function handles showing and hide each manual depending on whether or not
 * its title matches the query.
 * @param  {Object} e           Standard Event Object.
 * @param  {Array} manualsList An Array of all manuals titles and DOM Elements.
 * @param  {documentElement} noResults The wrapper element for the "No Results" message.
 * @return {void}
 */
function updateManualList(e, manualsList, noResults) {
  var query = e.target.value;
  var matches = getManualMatches(e, manualsList);

  manualsList.forEach(function(manual) {
    if ( -1 !== manual.title.indexOf(query) ) {
      manual.el.classList.remove('hide');
    } else {
      manual.el.classList.add('hide');
    }
  } );

  updateEmptyMessage(matches, noResults);
}

/**
 * Function loops over all the manuals and returns an array of all the matching manuals.
 * @param  {Object} e           Standard Event Object.
 * @param  {Array} manualsList An Array of all manuals titles and DOM Elements.
 * @return {Array}             An array of just the matching Manuals.
 */
function getManualMatches(e, manualsList) {
  var query = e.target.value;

  return manualsList.filter(function(manual) {
    return -1 !== manual.title.indexOf(query)
  } );
}

/**
 * Function queries the DOM for all Manual Elements. It then create a new Object which
 * contains a reference to the original DOM Element label as "el" and the Manual name
 * labeled as "title";
 * @return {Array} An array of all manauls in the DOM
 */
function getManualsList() {
  var manualsList = document.querySelectorAll('.manuals__item');

  return [].reduce.call( manualsList, function(acc, manual) {
    var manualTitle = manual.querySelector('p').innerText;
    return acc.concat([ { el: manual, title: manualTitle.toLowerCase() } ]);
  }, [] );
}


$(document).ready(function() {
  var sections = new slate.Sections();
  sections.register('header', theme.Header);
  sections.register('navigation', theme.Navigation);
  sections.register('product', theme.Product);
  sections.register('slideshow', theme.Slideshow);
  sections.register('rentals', theme.Races);
  sections.register('activations', theme.Races);
  sections.register('update-device', theme.UpdateDevice);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Wrap videos in div to force responsive layout.
  slate.rte.wrapTable();
  slate.rte.iframeReset();

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }
});
